const TIME = new Intl.DateTimeFormat("en-IN", {
  timeZone: "Asia/Kolkata",
  hour: "numeric",
  minute: "2-digit",
  hour12: true,
});

const DAY = new Intl.DateTimeFormat("en-IN", {
  timeZone: "Asia/Kolkata",
  day: "numeric",
  month: "short",
});

const DAY_KEY = new Intl.DateTimeFormat("en-CA", {
  timeZone: "Asia/Kolkata",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

/**
 * When a report's figures were read (#639): "Data as of 9:41 pm", with the
 * date as well once the read is from another day, India time.
 *
 * The time the answer arrived, not the report's own dates: a report of last
 * month read this morning is last month as it stood this morning.
 */
export function asOfLabel(readAt: number, now: number): string {
  const time = TIME.format(readAt).replace(/\s?(am|pm)$/i, (m) =>
    m.toLowerCase(),
  );
  const sameDay = DAY_KEY.format(readAt) === DAY_KEY.format(now);
  return sameDay
    ? `Data as of ${time}`
    : `Data as of ${DAY.format(readAt)}, ${time}`;
}
